// We have to separate out the span's that SplitText creates
// with the other tags (<u>, <i>, <b> etc) in order to animate
export const separateChildrenFromLine = line => {
  const spans = []
  const otherTags = []
  const children = [...line.children]

  children.forEach(child => {
    if (child.tagName !== "SPAN") {
      otherTags.push(child)
    } else {
      spans.push(child)
    }
  })

  return [spans, otherTags]
}
